import React from 'react';
import AppBar from 'material-ui/AppBar';

const UnAuthorizedHeader = (props) => {

    return (
        <AppBar title={<img alt="Loomis logo" style={{height: '64px'}} src="/images/logo-loomis.png" />} iconElementLeft={<div />} style={{backgroundColor: 'black'}} />
    );
}

export default UnAuthorizedHeader;



// WEBPACK FOOTER //
// ./src/components/UnAuthorizedHeader/UnAuthorizedHeader.js